export const GeneralHFields = [
    {
        identifier: 'font-family-headline',
        type: 'input',
        field: 'font-family-headline'
    }
]
